"use strict";

angular.module("vendor")
.controller("SectionRegistration", function(
    $scope, $rootScope, $state, $resource, $stateParams, $http, gettextCatalog, FlashBag, FormError, Language,
    PatternService, GroupService, UserService, VendorTypesService, common, EMAIL_MAXLENGTH, appConfig
) {
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    Language.initializeScope($scope, "language", null);
    Language.getLanguages().then(function(response) {
        $scope.Languages = response.data;
    });

    $scope.pattern = PatternService;
    $scope.CompanyTypes = VendorTypesService.query();
    $scope.SupplierID = ($stateParams.supplier ? $stateParams.supplier : null);
    $scope.groupInvite = ($stateParams.groupInvite ? $stateParams.groupInvite : null);
    $scope.User = {
        "number_delivery_days_allowed": 31,
        "OptInMarketing": false,
        departments: []
    };
    $scope.isArray = angular.isArray;
    var token = ($stateParams.token ? $stateParams.token : "");

    //Get supplier informations if a user click on link into the email to register
    if (token && $scope.SupplierID) {
        if (UserService.isLoggedIn()) {
            var unregister = $rootScope.$on("UserUpdated", function(event, user) {
                unregister();
                if ($scope.SupplierID == user.vendor.id)
                    $state.go("home");
                else
                    GetSupplierInfos();
            });
        }
        else {
            GetSupplierInfos();
        }
    }

    function GetSupplierInfos() {
        UserService.logout();

        //Get retailer info
        $http({
            method: "GET",
            url: appConfig.API_SERVER + "/auth/vendor/information/",
            params: {
                Token: token,
                SupplierID: $scope.SupplierID
            }
        }).then(
            function(response) {
                if (!response.data) {
                    var msg = gettextCatalog.getString("Cannot find your supplier information.");
                    FlashBag.preformattedError(msg);
                    token = "";
                }
                if (response.data.errorToken) {
                    var msgToken = gettextCatalog.getString("Your token is invalid.");
                    FlashBag.preformattedError(msgToken);
                    token = "";
                }
                if (response.data.userExists)
                    UserService.logoutAndRedirect("login");

                $scope.User = angular.extend($scope.User, response.data);
            }
        );
    }

    // On form submit, focus on the first error element
    function validate() {
        FormError.focus("SetRegister");
    }

    this.create = function() {
        $scope.isFormSubmit = true;

        FlashBag.clearAll();
        validate();

        if (!$scope.SetRegister) {
            return;
        }

        if (
            $scope.SetRegister.$valid
            || ($scope.SetRegister.Username.$error.invalid || $scope.SetRegister.Email.$error.used)
        ) {
            this.registerUser();
        }
    };

    this.registerUser = function(e) {
        $scope.User.Token = token;
        $scope.User = angular.extend({}, {
            Action: "Register",
            RegistrationType: "Supplier",
            groupInvite: $scope.groupInvite
        }, $scope.User);
        var fileNames = ["image_path"];
        var sendData = common.createFormDataFromFiles($scope.User, fileNames);

        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/auth/user/",
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined},
            data: sendData
        }).then(
            function onSuccess(data) {
                UserService.persistAuthToken(data);
                GroupService.addVendorGroupMembershipFromRegistration($scope.groupInvite);

                var unregister = $rootScope.$on("UserUpdated", function() {
                    unregister();
                    $state.go("home");
                });
            },
            function onError(response) {
                FlashBag.apiError(response);

                if (response.data && response.data.detail) {
                    response.data.detail = response.data.detail.replace(/\["Password", (?="[^"]+password)/i, '["", '); //Password prompts already mention they are for a password, so remove the title
                }

                if (!$scope.SetRegister) {
                    return;
                }

                if (response.data["Email"]) {
                    $scope.SetRegister.Email.$setValidity("used", false);
                }
                else {
                    $scope.SetRegister.Email.$setValidity("used", true);
                }

                if (response.data["Username"]) {
                    $scope.SetRegister.Username.$setValidity("invalid", false);
                }
                else {
                    $scope.SetRegister.Username.$setValidity("invalid", true);
                }
            }
        );
    };

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/auth/registration.controller.js
// module id = 977
// module chunks = 0